export default __webpack_public_path__ + "static/media/SMS_Dis.705e237e.svg";